import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { FilterCategory } from '../../Components/Public/Filters/FilterCategory.js';
import { CategoriesFamilies } from '../../Pages/Public/CategoriesFamilies.js';
import { Category } from '../../Pages/Public/Category.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteCategoriesFamilies = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [att, setAtt] = useState([]);
    const [ren, setRen] = useState([]);
    const [cha, setCha] = useState([]);
    const [arc, setArc] = useState([]);
    const [fam, setFam] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataArc = await fetch(`${backend}/nav/archives`, GetHeaders(guest));
            const arc = await dataArc.json();
            setArc(arc);
            const dataAtt = await fetch(`${backend}/nav/attractions`, GetHeaders(guest));
            const att = await dataAtt.json();
            setAtt(att);
            const dataCha = await fetch(`${backend}/nav/characters`, GetHeaders(guest));
            const cha = await dataCha.json();
            setCha(cha);
            const dataFam = await fetch(`${backend}/nav/family`, GetHeaders(guest));
            const fam = await dataFam.json();
            setFam(fam);
            const dataRen = await fetch(`${backend}/nav/rencontres`, GetHeaders(guest));
            const ren = await dataRen.json();
            setRen(ren);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    const cat = FilterCategory('home', att);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/categories-et-familles" element={<CategoriesFamilies navParks={navParks} att={att} cha={cha} ren={ren} arc={arc} fam={fam} />} />
                {cat.map((el, i) => {
                    return (<Route path={el.croute} element={<Category navParks={navParks} id={el.cid} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}
